import AuthCenterClient from 'auth-center-js-client'

type EnableMFAResponse = { mfa_session_key: string }

/**
 * Extends auth-center-js-client to treat MFA-required (428) as a successful session key response.
 */
export default class AccountSecurityClient extends AuthCenterClient {
    /**
     *
     */
    async enableMFAManually (): Promise<EnableMFAResponse> {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const client = this as any
        client._requireSession('enableMFA')

        const response = await fetch(`${client._baseUrl}/mfa/enable-mfa`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${client._sessionToken}`
            },
            body: JSON.stringify({})
        })

        const data = await response.json()

        if (response.status === 428 && data.message === 'mfa_required') {
            return { mfa_session_key: data.details.mfa_session_key }
        }

        if (!response.ok) {
            throw new Error(data.message || 'Something went wrong')
        }

        return data
    }
}
